import React, { useState, useEffect } from "react";
import { sendParentOtp, verifyParentOtp } from "../api/parentApi";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ParentLoginDialog = ({ open, handleClose }) => {
  const [identifier, setIdentifier] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(0);

  // Countdown timer
  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timer]);

  // Reset dialog state when closed
  useEffect(() => {
    if (!open) {
      resetState();
    }
  }, [open]);

  const resetState = () => {
    setIdentifier("");
    setOtp("");
    setOtpSent(false);
    setTimer(0);
  };

  const handleIdentifierChange = (e) => {
    const value = e.target.value;
    setIdentifier(value);

    // Reset OTP UI if user edits mobile/admission number
    if (otpSent) {
      setOtp("");
      setOtpSent(false);
      setTimer(0);
    }
  };

  const handleSendOtp = async () => {
    if (!identifier) return alert("Enter Mobile or Admission number");

    // TODO: Send OTP API
    try {

      const payload = identifier.match(/^\d+$/)
        ? { mobileNo: identifier }
        : { applicationId: identifier };

      const response = await sendParentOtp(payload);
      console.log(sendParentOtp);
      console.log("OTP Sent:", response);

      setOtpSent(true);
      setTimer(30);

    } catch (error) {
      alert(error.message);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) return alert("Enter OTP");

    try {
      const payload =
        identifier.length === 10
          ? { mobileNo: identifier, applicationId: null }
          : { mobileNo: null, applicationId: identifier };

      const result = await verifyParentOtp({
        ...payload,
        password: otp,
        deviceToken: "deviceToken",
      });

      if (result?.meta?.success) {

        const parentData = result.response;

        // Store token
        localStorage.setItem("parentToken", parentData.token);

        // Store parent info
        localStorage.setItem(
          "parentInfo",
          JSON.stringify({
            name: parentData.GurardianName,
            email: parentData.GurardianEmailId,
            planName: parentData.planName || "Free Plan",
            planPrice: parentData.planPrice || 0,
          })
        );

        console.log("Parent stored:", parentData);

        // Close the dialog first so Material UI can remove the scroll-lock from the HTML body
        handleClose();

        // Delay the reload just slightly so the dialog finishes its unmount animation
        setTimeout(() => {
          window.location.reload();
        }, 300);

      } else {
        alert(result?.meta?.successMessage || "Verification failed");
      }

    } catch (error) {
      console.error(error);
      alert("OTP verification failed");
    }
  };

  const handleResendOtp = () => {
    if (timer > 0) return;

    // TODO: Resend OTP API
    handleSendOtp()
    //setTimer(30);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ p: 4, position: "relative" }}>

        {/* CLOSE BUTTON */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.secondary",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h5" fontWeight={700} mb={1}>
          Log in to continue
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          Login using your registered mobile or admission number.
        </Typography>

        {/* Mobile / Admission Field */}
        <TextField
          fullWidth
          label="Mobile or Admission number"
          value={identifier}
          onChange={handleIdentifierChange}
          sx={{ mb: 1 }}
        />

        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          mb={3}
        >
          Example: 9876543210 or ADM10234
        </Typography>

        {/* Send OTP Button */}
        {!otpSent && (
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleSendOtp}
            sx={{ mb: 3 }}
          >
            Send OTP
          </Button>
        )}

        {/* OTP Section */}
        {otpSent && (
          <>
            <TextField
              fullWidth
              label="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              sx={{ mb: 3 }}
            />

            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleVerifyOtp}
            >
              Verify OTP
            </Button>

            <Box mt={2} textAlign="center">
              {timer > 0 ? (
                <Typography variant="caption" color="text.secondary">
                  Retry OTP in {timer}s
                </Typography>
              ) : (
                <Typography
                  variant="caption"
                  sx={{ cursor: "pointer", fontWeight: 600 }}
                  onClick={handleResendOtp}
                >
                  Resend OTP
                </Typography>
              )}
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ParentLoginDialog;